import { render, staticRenderFns } from "./addPolicy.vue?vue&type=template&id=24fedbe4&scoped=true&"
import script from "./addPolicy.vue?vue&type=script&lang=js&"
export * from "./addPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fedbe4",
  null
  
)

export default component.exports